<template>
  <div>
    <load-profile></load-profile>
    <b-tabs
      vertical
      content-class="col-12 col-md-9 mt-1 mt-md-0"
      pills
      nav-wrapper-class="col-md-3 col-12"
      nav-class="nav-left"
    >
      <!-- v-model="tabIndex" -->
      <!-- general tab -->
      <b-tab>
        <!-- title -->
        <template #title>
          <feather-icon icon="BoxIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">
            {{ $t("pages.voiceAlertSettings.title") }}
          </span>
        </template>
        <!-- <auto-messages/> -->
        <b-card ref="container" id="container">
          <b-card-text class="mb-2">
            <h5>
              {{ $t("pages.voiceAlertSettings.desc") }}
            </h5>
          </b-card-text>
          <text-editor
            :key="0"
            :id="newMessage.id"
            :title="$t('pages.voiceAlertSettings.newMessage.title')"
            :desc="$t('pages.voiceAlertSettings.newMessage.desc')"
            :param-options="[
              {
                label: 'operator_name_desc',
                value: '{{operatorName}}',
              },
            ]"
            v-model.lazy="newMessage.options"
            @update:textEditor="onUpdateTextEditor"
            @update:enable="onUpdateEnable"
            class="mb-2"
          />

          <text-editor
            :key="1"
            :id="msgWhenOperatorReplyLate.id"
            :title="$t('pages.voiceAlertSettings.operatorLateResponse.title')"
            :desc="$t('pages.voiceAlertSettings.operatorLateResponse.desc')"
            :time-notify-desc="
              $t('pages.voiceAlertSettings.operatorLateResponse.notify.desc')
            "
            v-model.lazy="msgWhenOperatorReplyLate.options"
            :param-options="[
              {
                label: 'operator_name_desc',
                value: '{{operatorName}}',
              },
              {
                label: 'count_unread_desc',
                value: '{{countLateReplyMessage}}',
              },
              {
                label: 'channel_name_desc',
                value: '{{channelName}}',
              },
            ]"
            @update:textEditor="onUpdateTextEditor"
            @update:enable="onUpdateEnable"
            class="mb-2"
          />

          <text-editor
            :key="2"
            :id="msgWhenOperatorReplyMissed.id"
            :title="$t('pages.voiceAlertSettings.operatorMissedResponse.title')"
            :desc="$t('pages.voiceAlertSettings.operatorMissedResponse.desc')"
            :time-notify-desc="
              $t('pages.voiceAlertSettings.operatorMissedResponse.notify.desc')
            "
            v-model.lazy="msgWhenOperatorReplyMissed.options"
            :param-options="[
              {
                label: 'operator_name_desc',
                value: '{{operatorName}}',
              },
              {
                label: 'count_unread_desc',
                value: '{{countLateReplyMessage}}',
              },
              {
                label: 'channel_name_desc',
                value: '{{channelName}}',
              },
            ]"
            @update:textEditor="onUpdateTextEditor"
            @update:enable="onUpdateEnable"
            class="mb-2"
          />
        </b-card>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { BCard, BTab, BTabs, BCardText, BButton } from "bootstrap-vue";
import TextEditor from "./components/TextEditor.vue";
import VoiceAlertSettingsRepository from "@/repositories/Api/VoiceAlertSettingsRepository";
import Update from "./components/QuickMessage/Update.vue";
import ChatAssignment from "./components/ChatAssignment.vue";

export default {
  components: {
    BCard,
    BCardText,
    BButton,
    TextEditor,
    BTab,
    BTabs,
    Update,
    ChatAssignment,
  },

  data: () => ({
    data: [],
    newMessage: {
      id: "",
      title: "",
      desc: "",
      options: {
        enable: false,
        locales: {
          en: "Hello",
          zh: "",
        },
      },
    },
    msgWhenOperatorReplyLate: {
      id: "",
      title: "",
      desc: "",
      options: {
        sendAfter: 60,
        enable: false,
        locales: {
          en: "Hello",
          zh: "",
        },
      },
    },
    msgWhenOperatorReplyMissed: {
      id: "",
      title: "",
      desc: "",
      options: {
        enable: false,
        locales: {
          en: "Hello",
          zh: "",
        },
      },
    },
  }),
  methods: {
    async getAlertVoiceSettings() {
      try {
        const response = await VoiceAlertSettingsRepository.show();
        const { data } = response.data;

        this.data = data;
        this.newMessage = this.mappingData("action.voiceAlertNewMessage");
        this.msgWhenOperatorReplyLate = this.mappingData(
          "action.voiceAlertMerchantNoResponse"
        );
        this.msgWhenOperatorReplyMissed = this.mappingData(
          "action.voiceAlertEndByCustomer"
        );
      } catch (err) {
        const { data } = err.response;
        const { message } = data;
        if (message === "error.recordNotFound")
          await this.createDefaultChatSettings();
      }
    },
    async createDefaultChatSettings() {
      try {
        await VoiceAlertSettingsRepository.show();
        await this.getAlertVoiceSettings();
      } catch (err) {
        alert(err);
      }
    },
    async updateVoiceAlertSettings(payloadUpdate, id) {
      try {
        const response = await VoiceAlertSettingsRepository.update(
          payloadUpdate,
          id
        );
      } catch (err) {
        alert(err);
      } finally {
        await this.getAlertVoiceSettings();
      }
    },
    async onUpdateEnable(event) {
      let payload = {
        enable: event.enable,
      };
      this.updateVoiceAlertSettings(payload, event.id);
    },
    async onUpdateTextEditor(event) {
      let payload = {
        notifySend: event?.sendAfter,
        message: event.locales,
      };
      this.updateVoiceAlertSettings(payload, event.id);
    },
    mappingData(codeAction) {
      let filterData = this.data.filter((item) => {
        return item.code == codeAction;
      });
      let settingMsg = filterData[0];
      const code = "action.voiceAlertMerchantNoResponse";

      let response = {
        id: settingMsg.id,
        title: settingMsg.title,
        desc: settingMsg.description,
        options: {
          enable: settingMsg.enable,
          sendAfter: codeAction == code ? settingMsg?.notifySend : undefined,
          locales: {
            en: settingMsg.message.en,
            zh: settingMsg.message.zh,
          },
        },
      };
      if (codeAction == "action.end") {
        delete response.options.sendAfter;
        response.options.closeTime = settingMsg.notifySend;
      } else if (codeAction == "action.endManual") {
        delete response.options.sendAfter;
      }
      return response;
    },
  },
  mounted() {
    this.getAlertVoiceSettings();
  },
  setup() {
    const permissionType = "voice-settings";
    return { permissionType };
  },
};
</script>